module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_2.4c7a0b24.png";